module.exports = __webpack_public_path__ + "static/img/L03.292ca81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/L03.jpg
// module id = yxpk
// module chunks = 9